import CaptchaProvider from './CaptchaProvider';

export default CaptchaProvider;
